import React, { useEffect } from "react";
import { Fade, Zoom } from "react-reveal";
import SubHeader from "../components/SubHeader";
import "./WhyChoose.css";

export default function WhyChoose() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const reason = (title, description) => (
    <div className="reason">
      <div className="icon-div"></div>
      <div className="detail">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
  return (
    <>
      <section className="why-choose" id="why-us">
        <div className="container">
          <Fade right>
            <div className="context">
              <div className="content">
                <SubHeader
                  title={"WHY Wellingtonia International School"}
                  subheader="we transform the way your child learns and grows"
                />
                <p>
                  At Wellingtonia International School, we transform learning by
                  nurturing your child's unique strengths, fostering creativity
                  and critical thinking, and empowering them to become
                  confident, independent learners prepared for the future.
                  Here’s why parents choose us:
                </p>
                <div className="reasons">
                  {reason(
                    "Personalized Learning",
                    "We understand that every child is unique. Our approach focuses on fostering personal understanding and development, ensuring no child is left behind."
                  )}
                  {reason(
                    "Certified Educators",
                    "Our teachers are fully certified and dedicated to helping each student succeed, with personalized support and innovative teaching methods."
                  )}
                  {reason(
                    "Flexible Learning Options",
                    "Our online model ensures students can learn from anywhere, and with our upcoming physical campuses, students can enjoy a hybrid learning experience that suits their needs."
                  )}
                  {reason(
                    "Beyond Academics",
                    "We celebrate talents, creativity, and emotional intelligence, preparing your child not just for exams but for life. Our programs build character and confidence for long-term success."
                  )}
                </div>
              </div>
            </div>
          </Fade>
          <Zoom>
            <div className="image"></div>
          </Zoom>
        </div>
      </section>
      <hr />
    </>
  );
}
